import { SwiperSlide } from 'swiper/react';

// components
import Card from '../../../../components/Price/Card/Card';
import Slider from '../../../../components/UI/Slider/Slider';

// style
import style from './price.module.css';

const Price = ({ item }) => {
  return (
    <section className={style.price}>
      <div className="container">
        <div className="title">
          <h2>
            Наши <span>цены</span>
          </h2>
          <span>
            Выбери свою игру <b>.</b>
          </span>
        </div>

        <Slider>
          {item.map((card) => (
            <SwiperSlide key={card.id}>
              <Card item={card} />
            </SwiperSlide>
          ))}
        </Slider>
      </div>
    </section>
  );
};

export default Price;
